import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '../../environments/environment';
import { HesabfaComparison, HesabfaExport } from './accounting.type';

interface Envelope<T> { result: T; }

/** The accounting module: exporting days to Hesabfa and comparing the two. */
@Injectable({ providedIn: 'root' })
export class AccountingService {
  private http = inject(HttpClient);
  private apiUrl = environment.apiBaseURL + '/accounting/hesabfa';

  /** Queues an export of the settlements paid on [from, to] (YYYY-MM-DD, Tehran days). */
  startExport(from: string, to: string): Observable<HesabfaExport> {
    return this.http.post<Envelope<HesabfaExport>>(`${this.apiUrl}/exports`, { from, to }).pipe(map(r => r.result));
  }

  listExports(): Observable<HesabfaExport[]> {
    return this.http.get<Envelope<HesabfaExport[]>>(`${this.apiUrl}/exports`).pipe(map(r => r.result));
  }

  /** Reads both sides live; nothing is stored. */
  compare(from: string, to: string): Observable<HesabfaComparison> {
    const params = new HttpParams().set('from', from).set('to', to);
    return this.http.get<Envelope<HesabfaComparison>>(`${this.apiUrl}/compare`, { params }).pipe(map(r => r.result));
  }
}
